import { useMutation, useQuery, useQueryClient } from "react-query";
import { createContractType, deleteContractType, fetchContractTypes, updateContractType, } from "@/features/contractType/services/contractTypeService";
const useContractTypeManagement = (page = 1, filters = {}, limit = 10) => {
    const queryClient = useQueryClient();
    const { data, error, isLoading, refetch } = useQuery(["employmentContractTypes", { page, filters, limit }], () => fetchContractTypes(page, filters, limit), {
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000,
    });
    const createMutation = useMutation((payload) => createContractType(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries("employmentContractTypes");
        },
    });
    const updateMutation = useMutation((payload) => updateContractType(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries("employmentContractTypes");
        },
    });
    const deleteMutation = useMutation((code) => deleteContractType(code), {
        onSuccess: () => {
            queryClient.invalidateQueries("employmentContractTypes");
        },
    });
    return {
        contractTypes: data?.items ?? [],
        meta: data?.meta ?? null,
        loading: isLoading,
        error: error?.message ?? null,
        handleCreateContractType: createMutation.mutateAsync,
        handleUpdateContractType: updateMutation.mutateAsync,
        handleDeleteContractType: deleteMutation.mutateAsync,
        refetchContractTypes: refetch,
    };
};
export default useContractTypeManagement;
